import React from "react";
import Slider from "react-slick";
import SvgCaretDown from "../../assets/icons/SvgCaretDown";
import { GatsbyImage } from "gatsby-plugin-image";
import { GalleryDialogContent } from "@/components/ui/dialog";

function ViewModal({ modalSlider, images, activeIndex, setActiveIndex }) {
  let innerSlider = React.useRef();
  const settings = {
    dots: false,
    speed: 500,
    infinite: false,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    pauseOnHover: false,
    touchMove: true,
    initialSlide: activeIndex,
  };

  return (
    <GalleryDialogContent className="flex flex-col max-w-full md:max-w-[530px] lg:max-w-[680px] xl:max-w-[700px] my-[7%] md:my-0 p-1">
      <div className="w-full h-full relative p-[10px] md:rounded-lg">
        <button
          className={`absolute shadow-lg bg-white rounded-full z-50 w-[50px] h-[50px] justify-center items-center left-0 md:-left-[25px]
          top-[30%] md:top-[calc(50%-25px)] ${
            activeIndex === 0 ? "hidden" : "flex"
          }`}
          onClick={() => {
            modalSlider?.slickPrev();
            innerSlider.slickPrev();
            setActiveIndex(activeIndex - 1);
          }}
        >
          <SvgCaretDown style={{ transform: "rotate(90deg)" }} />
        </button>
        <Slider ref={(c) => (innerSlider = c)} {...settings}>
          {images?.map(
            (image, index) => {
              if (image.__typename === "ShopifyMediaImage") {
                return image?.preview?.image?.gatsbyImageData && (
                    <GatsbyImage
                        key={index}
                        image={image.preview.image.gatsbyImageData}
                        alt={image.preview.image.altText}
                        className="w-full p-3 rounded-xl box-border aspect-[799/1024]"
                    />
                )
              }
              if (image.__typename === "Image") {
                return image?.originalSrc && (
                    <img
                        src={image.originalSrc}
                        alt={image.altText}
                        className="w-full p-3 rounded-xl box-border aspect-[799/1024]"
                        loading="lazy"
                    />
                )
              }
            }
          )}
        </Slider>
        <button
          className={`absolute shadow-lg bg-white rounded-full z-50 w-[50px] h-[50px] justify-center items-center right-0 md:-right-[25px]
          top-[30%] md:top-[calc(50%-25px)] ${
            activeIndex === images.length - 1 ? "hidden" : "flex"
          }`}
          onClick={() => {
            modalSlider?.slickNext();
            innerSlider.slickNext();
            setActiveIndex(activeIndex + 1);
          }}
        >
          <SvgCaretDown style={{ transform: "rotate(270deg)" }} />
        </button>
      </div>
    </GalleryDialogContent>
  );
}

export default React.memo(ViewModal);
